// AppDownloadCard.jsx

import companyLogo48 from "@/assets/appicons/Waggex-Company-App-Icon-48.png";
import staffLogo48 from "@/assets/appicons/Waggex-Staff-App-Icon-48.png";
import faceLensLogo48 from "@/assets/appicons/Waggex-FaceLens-App-Icon-48.png";

import companyqrcode from "@/assets/Company-App-Download-QR-Code.png";
import staffqrcode from "@/assets/Staff-App-Download-QR-Code.png";
import facelensqrcode from "@/assets/FaceLens-App-Download-QR-Code-100.png";

import mobile from "@/assets/waggex-hrms-app-download-android-ios-india.webp?w=200&format=webp";

const apps = [
  {
    title: "Payroll Software - Waggex",
    description:
      "Built for startups and companies to manage employees, attendance, payroll, shifts & daily operations from anywhere with one smart and easy-to-use HRMS platform.",
    logo: companyLogo48,
    qrCode: companyqrcode,
    link: "https://app.waggex.com/company-app-download.html",
  },
  {
    title: "Attendance App - Waggex",
    description:
      "Employees can mark attendance, apply leaves, view payslips, manage tasks, and stay connected with HR from anywhere using the mobile app. Scan QR To Download App.",
    logo: staffLogo48,
    qrCode: staffqrcode,
    link: "https://employee.waggex.com/staff-app-download.html",
  },
  {
    title: "Biometric Attendance - Waggex",
    description:
      "Transform any device into a smart attendance station with Waggex FaceLens App, featuring AI-powered face recognition, geo-fencing, and real-time employee attendance tracking.",
    logo: faceLensLogo48,
    qrCode: facelensqrcode,
    link: "https://app.waggex.com/facelens-app-download.html",
  },
];

export default function AppDownloadCard() {
  return (
    <section className="bg-[#ffffff] py-10 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center">
          <h2 className="font-roboto font-bold uppercase text-[#10324F] text-xl sm:text-3xl ">
            Download Waggex Mobile Apps
          </h2>

          <p className="mt-4 text-[#10324F] text-sm sm:text-base  mx-auto">
            Access Company, Staff & FaceLens Apps on Android & iOS. Scan the QR
            code to download and get started quickly
          </p>
        </div>

        {/* Content */}
        <div className="mt-10 flex flex-col lg:flex-row items-center gap-6">
          {/* App cards */}
          <div className="w-full space-y-4">
            {apps.map((app, index) => (
              <AppDetailDownloadCard key={index} {...app} />
            ))}
          </div>

          <div className="w-full flex justify-center">
            <img
              src={mobile}
              sizes="200px"
              width="200"
              height="409"
              loading="lazy"
              decoding="async"
              alt="Download Waggex HRMS mobile app on Android and iOS scan QR code to get started"
              className="object-contain hidden sm:block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
const AppDetailDownloadCard = ({ title, description, logo, qrCode, link }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="block">
      <div
        className="bg-white rounded-2xl overflow-hidden
        transition-shadow duration-300
        shadow-[-20px_-20px_30px_0_#D1DFEA4D,-15px_-15px_20px_0_#D1DFEA66_inset]
        hover:shadow-[0_4px_4px_0_#D1DFEA6B,-3px_-3px_10px_0_#D1DFEA_inset]
        p-3 sm:p-4 flex items-center justify-between gap-3
        w-full cursor-pointer"
      >
        {/* Left */}
        <div className="flex items-center gap-3 flex-1">
          <div className="w-12 h-12 rounded-lg overflow-hidden shrink-0">
            <img
              src={logo}
              alt={title}
              width="48"
              height="48"
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            <h2 className="text-[#10324F] font-semibold text-sm sm:text-lg">
              {title}
            </h2>

            <p className="text-[11px] sm:text-sm text-[#10324F] leading-5">
              {description}
            </p>
          </div>
        </div>

        {/* QR */}
        <div className="w-12 h-12 shrink-0">
          <img
            src={qrCode}
            width="48"
            height="48"
            alt="QR code"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </a>
  );
};
